<template>
    <span class="control-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
            <defs>
                <filter id="q7tjap193a" width="155.2%" height="155.2%" x="-27.6%" y="-27.6%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
                    <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g fill="none" fill-rule="evenodd" filter="url(#q7tjap193a)" transform="translate(15 15)">
                <circle cx="29" cy="29" r="29" fill="#DA4E4E"/>
                <path fill="#FFF" d="M22.57 28.414c-.652.273-1.072.969-.898 1.654.27 1.058-.096 2.222-1.02 2.924l-1.835 1.395c-1.232.936-2.99.696-3.927-.536l-1.395-1.835c-.935-1.232-.605-2.395.37-3.696.511-.683 1.332-1.433 1.332-1.433 7.718-7.025 19.825-6.985 27.448.03l1.583 1.585c1.13 1.076 1.544 2.653.641 3.91l-1.345 1.872c-.902 1.257-2.654 1.543-3.91.64L37.74 33.58c-.942-.677-1.339-1.832-1.098-2.897.153-.676-.109-1.372-.726-1.69-1.357-.703-3.299-1.646-6.423-1.915-2.709-.234-5.37.685-6.924 1.336"/>
            </g>
        </svg>
        <i>
            End call
        </i>
    </span>
</template>

<script>
export default {
    name: 'end-meeting'
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>